import { PagenotfoundComponent } from "./pagenotfound/pagenotfound.component";
import { ServicesComponent } from "./services/services.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { OrdersComponent } from "./listtransactions/orders.component";
import { LocationComponent } from "./location/location.component";
import { RolesComponent } from "./listdevices/roles.component";
import { UsersComponent } from "./users/users.component";
import { IncidentComponent } from "./incident/incident.component";
import { CustomersComponent } from "./customers/customers.component";
import { DetailsComponent } from "./detailsCutstomers/details.component";
import { ListTransactionsComponent } from "./list-transactions/list-transactions.component";
import { DetailsTransactionsComponent } from "./details-transactions/details-transactions.component";
import { ListQrpayCodeComponent } from "./list-qrpay-code/list-qrpay-code.component";
import { DetailQrpayCodeComponent } from "./detail-qrpay-code/detail-qrpay-code.component";
import { TokensManageComponent } from "./tokens-manage/tokens-manage.component";
import { CreateOrderComponent } from "./create-order/create-order.component";
import { LoginComponent } from "../account/auth/login/login.component";
import { DetailCreateOrderComponent } from "./detail-create-order/detail-create-order.component";
import { AuthRoleGuard } from "../core/guards/authRole.guard";
// import { ListWorkspaceComponent } from './list-workspace/list-workspace.component';
import { AccountComponent } from './account/account.component';
import { ListMemberComponent } from './list-member/list-member.component';
import { ListWorkspaceComponent } from './list-workspace/list-workspace.component';
import { DetailWorkspaceComponent } from './detail-workspace/detail-workspace.component';
import { SearchTransactionsComponent } from './search-transactions/search-transactions.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { DeviceStockComponent } from './device-stock/device-stock.component';
import { OrdersManagerComponent } from './orders-manager/orders-manager.component';
import { DeviceQrComponent } from './device-qr/device-qr.component';
import { DetalOrderComponent } from './detal-order/detal-order.component';
import { DashboardNewComponent } from './dashboard-new/dashboard-new.component';
import { GHNPendingComponent } from './ghn-pending/ghn-pending.component';
import { ManagerQrComponent } from './manager-qr/manager-qr.component';
import { BranchManagerComponent } from './branch-manager/branch-manager.component';
import { BranchHistoryComponent } from './branch-history/branch-history.component';
import { DetailHistoryComponent } from './detail-history/detail-history.component';
import { MBDashboardComponent } from './mb-dashboard/mb-dashboard.component';
import { RMManagementComponent } from './rm-management/rm-management.component';
import { ReferralCodeComponent } from './referral-code/referral-code.component';
import { DeviceComponent } from './device/device.component';
import { TransactionReportComponent } from './transaction-report/transaction-report.component';
import { ManagerGHNComponent } from './manager-ghn/manager-ghn.component';
import { ReturnManagerComponent } from './return-manager/return-manager.component';
import { DetailGhnPendingComponent } from './detail-ghn-pending/detail-ghn-pending.component';
import { ReturnConfirmComponent } from './return-confirm/return-confirm.component';
import { VtpPendingComponent } from './vtp-pending/vtp-pending.component';
import { SearchOrderComponent } from './search-order/search-order.component';
import { DetailSearchOrderComponent } from './detail-search-order/detail-search-order.component';
import { ExpiredpageComponent } from './expiredpage/expiredpage.component';
import { VccPendingComponent } from './vcc-pending/vcc-pending.component';
import { VccDoneComponent } from './vcc-done/vcc-done.component';
import { BranchOrdersComponent } from '../branch-orders/branch-orders.component';
import { ManagerBranchOrderComponent } from '../manager-branch-order/manager-branch-order.component';
import { AnonQrComponent } from './anon-qr/anon-qr.component';
import { RenewManagementComponent } from './renew-management/renew-management.component';
import { AffiliateOrderComponent } from './affiliate-order/affiliate-order.component';
import { ZNSManagerComponent } from './zns-manager/zns-manager.component';
import { ManagerInvoiceComponent } from './manager-invoice/manager-invoice.component';
import { DetailInvoiceComponent } from "./detail-invoice/detail-invoice.component";


const routes: Routes = [
  // {
  //     path: '',
  //     redirectTo:'login',
  //     pathMatch: 'full'
  // },
  // { path: '', component: LoginComponent},
  {
    path: "",
    component: DashboardNewComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation", "switchboard"],
    },
  },
  {
    path: "search-orders",
    component: SearchOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "switchboard"],
    },
  },
  {
    path: "search-orders/detail-orders/:id",
    component: DetailSearchOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "switchboard"],
    },
  },
  {
    path: "return-manager",
    component: ReturnManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["operation", "admin", "customer service", "delivery"],
    },
  },
  {
    path: "expired-page",
    component: ExpiredpageComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery"],
    },
  },
  {
    path: "vcc-done",
    component: VccDoneComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery"],
    },
  },
  {
    path: "vcc-pending",
    component: VccPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery"],
    },
  },
  {
    path: "branch-orders",
    component: BranchOrdersComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "partner_operation"],
    },
  },
  {
    path: "manager-branch-orders",
    component: ManagerBranchOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "delivery",
      ],
    },
  },
  {
    path: "vcc-Pending/detail-pending-vcc/:id",
    component: DetailGhnPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "opreation", "customer service"],
    },
  },
  {
    path: "return-manager/detail-orders/:id",
    component: DetalOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery", "operation"],
    },
  },
  {
    path: "return-confirm",
    component: ReturnConfirmComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["operation", "admin", "customer service", "delivery"],
    },
  },
  {
    path: "return-confirm/detail-orders/:id",
    component: DetalOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery", "operation"],
    },
  },
  {
    path: "edit-profile",
    component: EditProfileComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },
  //token
  {
    path: "tokens",
    component: TokensManageComponent,
    canActivate: [AuthRoleGuard],
  },
  {
    path: "person",
    component: AccountComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },

    //devices
    {
        path: 'deviceslist', component: RolesComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin']
        }
    },
    {
        path: 'device-stock', component: DeviceStockComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin']
        }
    },
    {
        path: 'orders-manager', component: OrdersManagerComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'customer service', 'operation', 'delivery']
        }
    },
    {
        path: 'GHN-Pending', component: GHNPendingComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'delivery', 'operation', 'customer service']
        }
    },
    {
        path: 'GHN-Manager', component: ManagerGHNComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'delivery', 'operation', 'customer service']
        }
    },
    {
        path: 'GHN-Pending/detail-pending-ghn/:id', component: DetailGhnPendingComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'delivery', 'opreation', 'customer service']
        }
    },
    {
        path: 'VTP-Pending/detail-pending-vtp/:id', component: DetailGhnPendingComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'delivery', 'opreation', 'customer service']
        }
    },
    {
        path: 'VTP-Pending', component: VtpPendingComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'delivery', 'operation', 'customer service']
        }
    },
    {
        path: 'orders-manager/detail-orders/:id', component: DetalOrderComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'customer service', 'delivery']
        }
    },
    {
        path: 'invoice-manager/detail-orders/:id', component: DetailInvoiceComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'customer service', 'delivery']
        }
    },
    {
        path: 'GHN-Manager/detail-orders/:id', component: DetalOrderComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'customer service', 'delivery']
        }
    },
    {
        path: 'users', component: UsersComponent
        , canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin']
        }
    },
    // { path: 'booking', component: BookingComponent },
    // { path: 'location', component: LocationComponent, canActivate: [AuthRoleGuard], data: {
    //         accessRole: ['admin', 'user']
    //     } },
    // { path: 'incident', component: IncidentComponent, canActivate: [AuthRoleGuard], data: {
    //         accessRole: ['admin', 'user']
    //     } },
    {
        path: 'users/details/:id', component: DetailsComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'user']
        }
    },

  //transactions
  {
    path: "transactions/details-transactions/:id",
    component: DetailsTransactionsComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  // { path: '404', component: PagenotfoundComponent, canActivate: [AuthRoleGuard], data: {
  //     accessRole: ['admin','user']
  // } },
  {
    path: "transactions",
    component: ListTransactionsComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "transactions-qr",
    component: ManagerQrComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation"],
    },
  },
  {
    path: "search-transactions",
    component: SearchTransactionsComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },
  //qr-pay
  {
    path: "qrpay-code",
    component: ListQrpayCodeComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "qrpay-code/:id",
    component: DetailQrpayCodeComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "detail-qrpay-code",
    component: DetailQrpayCodeComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },

  //create-order
  {
    path: "create-order",
    component: CreateOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },
  {
    path: "detail-create-order",
    component: DetailCreateOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },

  //member
  {
    path: "member",
    component: ListMemberComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "device-qr",
    component: DeviceQrComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service"],
    },
  },

    //workspace
    {
        path: 'workspaces', component: ListWorkspaceComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'user']
        }
    },
    {
        path: 'workspaces/detail-workspace/:id', component: DetailWorkspaceComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'user']
        }
    },
    {
        path: 'MB-dashboard', component: MBDashboardComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'partner_operation'  , 'branch_operation' , 'iris_operation' ,'iris_partner']
        }
    },
    {
        path: 'branch', component: BranchManagerComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'partner_operation'  , 'branch_operation' , 'iris_operation' ,'iris_partner']
        }
    },
    {
        path: 'branch/detail-branch/:id', component: BranchHistoryComponent, canActivate: [AuthRoleGuard], data: {
          accessRole: ['admin', 'partner_operation'  , 'branch_operation' , 'iris_operation' ,'iris_partner']
        }
    },
    {
        path: 'branch/detail-history/:id', component: DetailHistoryComponent, canActivate: [AuthRoleGuard], data: {
          accessRole: ['admin', 'partner_operation'  , 'branch_operation' , 'iris_operation' ,'iris_partner']
        }
    },
    {
        path: 'rm-management', component: RMManagementComponent, canActivate: [AuthRoleGuard], data: {
          accessRole: ['admin', 'partner_operation'  , 'branch_operation' , 'iris_operation' ,'iris_partner']
        }
    },
    {
        path: 'referral-code', component: ReferralCodeComponent, canActivate: [AuthRoleGuard], data: {
          accessRole: ['admin', 'partner_operation'  , 'branch_operation' , 'iris_operation' ,'iris_partner']
        }
    },
    {
        path: 'device-agency', component: DeviceComponent, canActivate: [AuthRoleGuard], data: {
          accessRole: ['admin', 'partner_operation'  , 'branch_operation' , 'iris_operation' ,'iris_partner']
        }
    },
    {
        path: 'transaction-report', component: TransactionReportComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'operation']
        }
    },
    {
        path: 'anon-qr', component: AnonQrComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin']
        }
    },
    {
        path: 'renew-package', component: RenewManagementComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin']
        }
    },
    {
        path: 'affiliate-order', component: AffiliateOrderComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin']
        }
    },
    {
        path: 'affiliate-order/detail-orders/:id', component: DetailGhnPendingComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin', 'customer service', 'delivery']
        }
    },
    {
        path: 'zns-manager', component: ZNSManagerComponent, canActivate: [AuthRoleGuard], data: {
            accessRole: ['admin']
        }
    },
    {
      path: 'invoice-manager', component: ManagerInvoiceComponent, canActivate: [AuthRoleGuard], data: {
        accessRole: ['admin', 'operation']
      }
  },
    // { path: 'kanban-board', component: KanbanComponent },
    // { path: 'settings', component: SettingsComponent },
    // { path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
    // { path: 'email', loadChildren: () => import('./email/email.module').then(m => m.EmailModule) },
    // { path: 'pages', loadChildren: () => import('./utility/utility.module').then(m => m.UtilityModule) },
    // { path: 'ui', loadChildren: () => import('./ui/ui.module').then(m => m.UIModule) },
    // { path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule) },
    // { path: 'charts', loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule) },
    // { path: 'form', loadChildren: () => import('./form/form.module').then(m => m.FormModule) },
    // { path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule) },
    // { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) },
    // { path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportModule) },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
